export default __webpack_public_path__ + "static/media/uni.2479e47e.png";